module.exports = __webpack_public_path__ + "static/auto_2-610a1a03db32bf853cca6b3ebc5f922a.jpg";